atomic-result-printable-uri {
  max-width: 100%;
  word-break: break-word;

  a,
  button {
    color: var(--atomic-primary);

    &:hover,
    &:focus-visible {
      text-decoration: underline;
      color: var(--atomic-primary);
    }

    &:focus {
      outline: none;
    }

    &:visited {
      color: var(--atomic-visited);
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
  }

  li {
    display: inline-flex;
    align-items: center;
    max-width: 100%;

    a {
      display: inline-block;
      vertical-align: middle;
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    white-space: nowrap;
    &:last-child {
      white-space: normal;

      &::after {
        content: none;
      }
    }

    .result-printable-uri-separator {
      display: inline-block;
      margin: 0 0.5rem;
      vertical-align: middle;
      width: 0.75rem;
      height: 0.75rem;
      color: var(--atomic-neutral-dark);
    }
  }
}
